import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
/** Details for claimed authentication. */
export function ClaimedDetails() {
    return (_jsx(Text.Paragraph, { children: "Name and email are requested before starting a conversation. An icon is displayed in the agent interface to indicate that the user has identified themselves." }));
}
